export const DEFAULT_ACCEPT = '.jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp';

/**
 * True when the dropzone is meant for images (photo widget, posters, avatars).
 *
 * @param {string} [accept]
 * @returns {boolean}
 */
export function fileUploadAcceptsImages(accept) {
    return /image/i.test(String(accept || DEFAULT_ACCEPT));
}

/**
 * Preview URL for a stored redux-form value (data URL after client-side processing).
 *
 * @param {unknown} value
 * @returns {string|null}
 */
export function fileUploadPreviewSrc(value) {
    if (typeof value !== 'string' || !value)
        return null;
    if (value.startsWith('data:image/'))
        return value;
    return null;
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function fileUploadHasStoredValue(value) {
    return typeof value === 'string' && value.length > 0;
}

/**
 * Event-poster hand-off owns the value; form fields must keep the data URL.
 *
 * @param {unknown} onAfterChange
 * @returns {boolean}
 */
export function shouldKeepFileUploadValue(onAfterChange) {
    return typeof onAfterChange !== 'function';
}

/**
 * @param {{ isImage: boolean, multiple: boolean }} params
 * @returns {string}
 */
export function fileUploadHintKey({ isImage, multiple }) {
    if (isImage)
        return multiple ? 'common.drag_images' : 'common.drag_one_image';
    return multiple ? 'common.drag_files' : 'common.drag_one_file';
}
